"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Aside;
var _react = _interopRequireDefault(require("react"));
function Aside(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: -1,
    className: "ehp-aside",
    dangerouslySetInnerHTML: {
      __html: props.label
    }
  });
}